module.exports = __webpack_public_path__ + "static/img/default_pic.2e9c2bc1.png";